import {
  gameState,
  hiveState,
  inventoryState,
  playerState,
} from "../state/stateManager";
import Coin from "./../../res/coin.png";
export function createHtmlHud() {}

export default class HtmlHud {
  constructor() {
    console.log(
      "inside createHtmlHud, gameState is: ",
      gameState,
      " Hivestate is : ",
      hiveState
    );
    let hud = document.getElementById("hud");
    hud.style.display = "flex";
    this.bankObject = document.getElementById("bank");
    this.dateObject = document.getElementById("date");
    this.progress = document.getElementById("inventory");
    this.explanation = document.getElementById("openExplanation");
    this.stings = document.getElementById("stings");
    this.explanation.innerHTML = `<h1>I: Interface</h1>`;
    this.showData();
    this.clockTick = setInterval(() => {
      this.showData();
    }, 3000);
  }
  showData() {
    let date = gameState.getGameDate();
    let coins = gameState.getCoins();
    let nature = this.seasonRate(date.dayOfYear);
    console.log("hud nature; ", nature);
    let netNectar = nature.honeyIn - nature.honeyOut;

    if (date) {
      let hours = date.hours;
      let minutes = date.min;
      if (hours.toString().length < 2) {
        hours = "0" + hours.toString();
      }
      if (minutes.toString().length < 2) {
        minutes = minutes.toString() + "0";
      }

      const dateDisplay = this.figureOutDate(date.dayOfYear);

      this.dateObject.innerHTML = `
          
          <h1>${dateDisplay.month + " " + dateDisplay.date}</h1>
          <p>${
            "Year:" + date.years
          }</p><div id="nectarDisplay" class="progress"><p>Nectar</p><div class="progressIndication"id="nectarCurrent" style="width:${
        100 * netNectar
      }px;"></div></div>
          `;
      this.bankObject.innerHTML = `<p><img class="bankCoin" src="${Coin}"/>$${coins}</p>`;
      this.progressData = this.getProgress();

      this.progress.innerHTML = `<div id="achievementsProgress" class="progress">
                                      <p>Achievements</p>
                                      <div class="progressIndication" style="width:${this.progressData.achievements}px"></div>
                                </div>
                                <div id="brandProgress" class="progress">
                                      <p>Brand Awareness</p>
                                      <div class="progressIndication" style="width:${this.progressData.brandAwareness}px"></div>
                                </div>`;
      this.stings.innerHTML = `<div id="zealProgress" class="progress">
                                      <p>Zeal</p>
                                      <div class="progressIndication" style="width:${this.progressData.zeal}px"></div>
                                      
                                </div> <p>Experience: ${this.progressData.experience} Sting Tolerance: ${this.progressData.stingTolerance}</p>`;
    }
  }
  getProgress() {
    let content = playerState.getContent();
    const achievementsTotal = content.possibleAchievements.length;
    const achieved = content.achievements.length;
    const achievementFraction = achieved / achievementsTotal;

    const brandFraction = content.brandAwareness / 100;
    let zeal = 350;
    let reduceFraction = content.stings.count / content.stingTolerance;
    const calculatedZeal = zeal * reduceFraction;
    const realZeal = zeal - calculatedZeal;
    console.log("zeal should be ", realZeal);

    return {
      achievements: achievementFraction * 350,
      brandAwareness: brandFraction * 350,
      zeal: realZeal,
      stingTolerance: content.stingTolerance,
      experience: content.experience,
    };
  }
  cancelHud() {
    hud.style.display = "none";
    clearInterval(this.clockTick);
  }
  figureOutDate(dayOfYear) {
    let month = null;
    let date = null;
    if (dayOfYear <= 31) {
      month = "Jan";
      date = dayOfYear;
    } else if (dayOfYear >= 32 && dayOfYear <= 59) {
      month = "Feb";
      date = dayOfYear - 31;
    } else if (dayOfYear >= 60 && dayOfYear <= 90) {
      month = "Mar";
      date = dayOfYear - 59;
    } else if (dayOfYear >= 91 && dayOfYear <= 120) {
      month = "Apr";
      date = dayOfYear - 90;
    } else if (dayOfYear >= 121 && dayOfYear <= 151) {
      month = "May";
      date = dayOfYear - 120;
    } else if (dayOfYear >= 152 && dayOfYear <= 181) {
      month = "Jun";
      date = dayOfYear - 151;
    } else if (dayOfYear >= 182 && dayOfYear <= 212) {
      month = "Jul";
      date = dayOfYear - 181;
    } else if (dayOfYear >= 213 && dayOfYear <= 243) {
      month = "Aug";
      date = dayOfYear - 212;
    } else if (dayOfYear >= 244 && dayOfYear <= 273) {
      month = "Sep";
      date = dayOfYear - 243;
    } else if (dayOfYear >= 274 && dayOfYear <= 304) {
      month = "Oct";
      date = dayOfYear - 273;
    } else if (dayOfYear >= 305 && dayOfYear <= 334) {
      month = "Nov";
      date = dayOfYear - 304;
    } else if (dayOfYear >= 335 && dayOfYear <= 365) {
      month = "Dec";
      date = dayOfYear - 334;
    }
    return { month, date };
  }
  seasonRate(startDate, timeSpan) {
    if (startDate >= 0 && startDate <= 60) {
      return { honeyIn: -1, brood: -1, honeyOut: 1, lifeSpan: 3 };
    }
    if (startDate > 60 && startDate <= 90) {
      return { honeyIn: 0.3, brood: 1.6, honeyOut: 0.5, lifeSpan: 2.5 };
    }
    if (startDate > 90 && startDate <= 110) {
      return { honeyIn: 1, brood: 1.6, honeyOut: 0.3, lifeSpan: 2 };
    }
    if (startDate > 110 && startDate <= 130) {
      return { honeyIn: 0.3, brood: 1, honeyOut: 0.3, lifeSpan: 2 };
    }
    if (startDate > 130 && startDate <= 200) {
      return { honeyIn: 1.1, brood: 1.6, honeyOut: 0.3, lifeSpan: 1.5 };
    }
    if (startDate > 200 && startDate <= 250) {
      return { honeyIn: 0.6, brood: 1.2, honeyOut: 0.1, lifeSpan: 5 };
    }
    if (startDate > 250 && startDate <= 285) {
      return { honeyIn: 1.1, brood: 0.6, honeyOut: 0.1, lifeSpan: 5 };
    }
    if (startDate > 285 && startDate <= 330) {
      return { honeyIn: 0.2, brood: 0.3, honeyOut: 0.4, lifeSpan: 5 };
    }
    if (startDate > 330) {
      return { honeyIn: -1, brood: -1, honeyOut: 1, lifeSpan: 3 };
    }
  }
}
